import { css } from '@emotion/core'
import { colors } from '@bonitour/components'

export const containerButton = css`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title {
    margin: 0;
  }
`

export const tableV2Container = css`
  .red {
    color: ${colors.red1};
  }

  .green {
    color: ${colors.green1};
  }

  .TableRow {
    .TableCell {
      overflow: initial;
    }

    color: ${colors.gray3};
    cursor: pointer;
  }
`

export const modalContainer = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.625rem;
  color: ${colors.gray3};
  border: 0.0625rem solid ${colors.gray6};
  padding: 0.625rem;
  margin: 1.25rem 0;
  border-radius: 0.625rem;

  div {
    display: flex;
    gap: 0.625rem;
  }

  p:first-of-type {
    font-weight: 700;
  }

  .red {
    color: ${colors.red1};
  }

  .green {
    color: ${colors.green1};
  }

  @media(max-width: 33.75rem){
    grid-template-columns: repeat(1, 1fr);
  }

  @media(max-width: 28.125rem){
    grid-template-columns: repeat(1, 1fr);
    font-size: 0.875rem;
  }
`

export const headerTitleStyle = css`
  color: ${colors.gray2};
  margin: 1.25rem 0;
`
